import dayjs from 'dayjs';
import strings from '../../Globalization';
import consts from '../../consts';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';


export const evalTopSection = ({ data }) => {
	return data.TopSection.map(item => {

		if (item.HeaderLabel === consts.processMonitoring) {
				item.element = <ProcessMonitoringStatus CriticalParameterIcon={item.value} align='left' ml={0} />			
			return { ...item };
		}
		return { ...item }
	});
};


export const getPrintDetailsParams = ({ data, dateTimeFormat, equipmentFamilyId }) => {
	let topSection = evalTopSection({ data, dateTimeFormat, equipmentFamilyId });
	topSection = topSection.map((item) => ({
		...item,
		Label: strings[item.HeaderLabel],
		Value: item.hasOwnProperty('image') ? '' : item.value,
		Image: item.image || '',
		ImageColor: item.imageColor || '',
		Index: item.index >= 0 ? item.index : -1
	}));
	const printData = data.CycleTape || data.PrinterLines || '';
	const pageInfo = [
		{ Property: 'ReportTitle', Value: strings.CycleLogs || '', LangString: strings.CycleLogs },
		{ Property: 'EquipmentName', Value: data.EquipmentName || '', LangString: strings.EquipmentName },
		{ Property: 'EquipmentType', Value: data.EquipmentTypeName || '', LangString: strings.EquipmentType },
		{ Property: 'SerialNumber', Value: data.SerialNumber || '', LangString: strings.SerialNumber },
		{ Property: 'ModelName', Value: data.ModelName || '', LangString: strings.ModalName },
		{ Property: 'Location', Value: data.LocationName || '', LangString: strings.LocationName },
		{ Property: 'CycleCount', Value: data.CycleCount || '', LangString: strings.CycleCount },
		{
			Property: 'CycleDate',
			Value: dayjs(data.CycleStart).format(dateTimeFormat.datetime) || '',
			LangString: strings.CycleDateTime
		},
		{ Property: 'Parameter', LangString: strings.Parameter },
		{ Property: 'Metric', LangString: strings.Metric },
		{ Property: 'Actual', LangString: strings.Actual },
		{ Property: 'CriticalParamenterTitle', LangString: strings.CriticalParamenterTitle }
	];

	const criticalParameters = data.CriticalParameters.map((obj) => ({
		HeaderLabel: strings[obj.HeaderLabel] || obj.HeaderLabel,
		SubHeaderLabel: obj.SubHeaderLabel || '',
		Index: obj.Index || 0,
		UnitHeader: obj.UnitHeader || '',
		UnitSubHeader: obj.UnitSubHeader || '',
		ColSpan: obj.ColSpan || 0,
		RowSpan: obj.RowSpan || 0,
		Metric: obj.Metric || '',
		Actual: obj.Actual || '',
		CriticalParameterIcon: obj.CriticalParameterIcon,
		Control: obj.Control || '',
		Independent: obj.Independent || '',
		TabHeader: obj.TabHeader || false
	})).filter((obj) => obj.HeaderLabel);
	const requestParameters = [
		{ Name: 'action', Value: 'otherAction' },
		{ Name: 'otherAction', Value: 'printReport' },
		{ Name: 'cycleCount', Value: data.CycleCount },
		{ Name: 'imageUrl', Value: data.CycleImageUrl },
		{ Name: 'cycleName', Value: data.CycleName },
		{ Name: 'cycleTape', Value: printData },
		{ Name: 'topSection', Value: JSON.stringify(topSection) },
		{ Name: 'criticalParameters', Value: JSON.stringify(criticalParameters) },
		{ Name: 'pageInfo', Value: JSON.stringify(pageInfo) },
		{ Name: 'isWasherOrLCS', Value: true }
	];
	return requestParameters;
};

